import EditorLayout from './EditorLayout';
import { EditorLayoutProps, EditorLayoutValueProps } from './types';

export type { EditorLayoutProps, EditorLayoutValueProps };
export default EditorLayout;
